import request from "@/utils/request";

// 能源统计

// 查询能源统计综合信息 #10261
export const getEnergyStatsV2 = params => {
	return request({
		url: "/energy/stats/v2",
		method: "GET",
		params,
	});
};

// 查询能源统计综合信息
export const getEnergyStatsByPeriod = params => {
	return request({
		url: "/energy/stats/period",
		method: "GET",
		params,
	});
};
// 查询统计利用率
export const biStats = data => {
	return request({
		url: "/bi/stats",
		method: "POST",
		data,
	});
};